import React from "react";
import PersonOutline from "@mui/icons-material/PersonOutline";
import EmailOutlined from "@mui/icons-material/EmailOutlined";
import PhoneOutlined from "@mui/icons-material/PhoneOutlined";
import ArrowForward from "@mui/icons-material/ArrowForward";
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  Modal,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

const ContactModal = ({ setOpenModal, openModal }) => {
  const theme = useTheme();

  const handleCloseModal = () => setOpenModal(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const fd = new FormData(form);
    const payload = Object.fromEntries(fd.entries());

    if (!payload.first_name || !payload.email) {
      alert("Please fill in First name and Email.");
      return;
    }

    try {
      const res = await fetch("https://formspree.io/f/xwprvzjd", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        //TODO: add success snackbar
        alert("Thanks! Your message has been sent.");
        form.reset();
        handleCloseModal();
      } else {
        const errorData = await res.json();
        console.error("Formspree error:", errorData);
        alert("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.error("Network error:", err);
      alert("Network error. Please try again.");
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: theme.palette.primary.main,
          border: "1px solid #fff",
          boxShadow: 24,
          width: 900,
          p: 2,
          gap: 4,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          borderRadius: 2,
        }}
      >
        <Box sx={{ width: "70%", p: 1 }}>
          <Typography variant="h4" sx={{ color: "#fff", mb: 4 }}>
            Let's Connect! We're Eager to Hear from You!
          </Typography>

          <FormControl
            component="form"
            onSubmit={handleSubmit}
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mb: 2,
              }}
            >
              <TextField
                name="first_name"
                required
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  border: "0.5px solid rgba(255, 255, 255, 0.5)",
                  width: "50%",
                  borderRadius: 2,
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
                fullWidth
                placeholder="First name"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutline sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                name="last_name"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  border: "0.5px solid rgba(255, 255, 255, 0.5)",
                  width: "50%",
                  borderRadius: 2,
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
                fullWidth
                placeholder="Last name"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonOutline sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mb: 2,
              }}
            >
              <TextField
                name="email"
                type="email"
                required
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  border: "0.5px solid rgba(255, 255, 255, 0.5)",
                  width: "50%",
                  borderRadius: 2,
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
                fullWidth
                placeholder="Email"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailOutlined sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                name="phone"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  border: "0.5px solid rgba(255, 255, 255, 0.5)",
                  width: "50%",
                  borderRadius: 2,
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
                fullWidth
                placeholder="Phone"
                typeof="number"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PhoneOutlined sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box
              sx={{
                width: "100%",
                mb: 2,
              }}
            >
              <TextField
                name="message"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  border: "0.5px solid rgba(255, 255, 255, 0.5)",
                  borderRadius: 2,
                  "& .MuiInputBase-input": {
                    color: "#fff",
                  },
                  "& .MuiInputBase-input::placeholder": {
                    color: "#fff",
                    opacity: 0.7,
                  },
                }}
                fullWidth
                placeholder="Message"
                variant="outlined"
                multiline
                minRows={5}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{ alignSelf: "flex-start" }}
                    >
                      <EmailOutlined sx={{ color: "#fff" }} />
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Button
              type="submit"
              variant="outlined"
              endIcon={<ArrowForward />}
              sx={{
                alignSelf: "flex-end",
                color: "rgba(255,255,255,0.95)",
                borderColor: "rgba(255,255,255,0.4)",
                px: 3,
                py: 1.25,
                width: "100%",
                maxWidth: 250,
                textTransform: "none",
                borderRadius: 1,
                "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
              }}
            >
              Send a Message
            </Button>
          </FormControl>
        </Box>

        <Box
          sx={{
            width: "30%",
            borderLeft: "1px solid white",
            pl: 2,
            pt: 1,
          }}
        >
          <Typography variant="h4" sx={{ color: "#fff", mb: 4 }}>
            Prefer meeting?
          </Typography>
          <Typography variant="h5" sx={{ color: "#fff", mb: 2 }}>
            Whether you have questions, ideas, or simply want to explore how we
            can collaborate, we're here to discuss your needs and goals in
            detail. Reach out to us to schedule a meeting at your convenience.
          </Typography>
          <Button
            type="submit"
            variant="outlined"
            endIcon={<ArrowForward />}
            href="https://calendar.app.google/yyQ665soutqZzj1H9"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              alignSelf: "flex-end",
              color: "rgba(255,255,255,0.95)",
              borderColor: "rgba(255,255,255,0.4)",
              px: 3,
              py: 1.25,
              width: "100%",
              textTransform: "none",
              borderRadius: 1,
              "&:hover": { borderColor: "rgba(255,255,255,0.75)" },
            }}
          >
            Schedule a call
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ContactModal;
